<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <ModalItem v-if="modalShowItem" @closeModal="closeModal" :item="selectedItem" />
  <ModalConfirmStatus v-if="showStatusModal" @closeModal="closeStatusModal" @statusUpdated="fetchItems"
    :item="selectedItem" />
  <IndexView />
  <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ hidden: !isBlur }"></div>
  <ViewContainer>
    <section class="p-6">
      <PageTitle title="Item" />
      <div class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg">
        <div id="table-header" class="mb-5 flex justify-between">
          <AddButton to_url="#" button_text="+ Tambah Item" button_class="text-base py-2 font-medium"
            @click="showModal" />
          <div class="flex gap-2 items-center">
            <InputSelect v-model="selectedItemCategory" :options="categoryOptions" optionLabel="name" optionValue="id"
              placeholder="Pilih Kategori" />
            <SearchBox placeholder="Cari item..." v-model="searchQuery" />
          </div>
        </div>
        <div class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell>Code</TableHeadCell>
                    <TableHeadCell>Kategori</TableHeadCell>
                    <TableHeadCell>Nama Item</TableHeadCell>
                    <!-- <TableHeadCell>Menu Type</TableHeadCell> -->
                    <!-- <TableHeadCell>Unit</TableHeadCell> -->
                    <!-- <TableHeadCell>Barcode</TableHeadCell> -->
                    <TableHeadCell>Sale Price</TableHeadCell>
                    <!-- <TableHeadCell>Purchase Price</TableHeadCell> -->
                    <TableHeadCell>Service Charge</TableHeadCell>
                    <TableHeadCell>Tax</TableHeadCell>
                    <TableHeadCell>Discount</TableHeadCell>
                    <TableHeadCell>Status</TableHeadCell>
                    <TableHeadCell>Action</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="allItems.length == 0">
                    <TableCell colspan="12" customClass="text-center italic text-gray-400 dark:text-gray-500"
                      noTextColor>
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <TableRow v-else v-for="(item, index) in allItems" :key="item.id" :index="index" isBody>
                    <TableCell>{{ index + 1 }}</TableCell>
                    <TableCell>{{ item.code }}</TableCell>
                    <TableCell>{{ getCategoryName(item.item_category_id) }}</TableCell>
                    <TableCell>{{ item.name }}</TableCell>
                    <!-- <TableCell>{{ item.menu_type }}</TableCell> -->
                    <!-- <TableCell>{{ item.unit }}</TableCell> -->
                    <!-- <TableCell>
                      <img :src="item.barcode || defaultBarcodeImage" :alt="item.barcode || 'Default Barcode'"
                        class="h-8" @error="$event.target.src = defaultBarcodeImage" />
                    </TableCell> -->
                    <TableCell>{{ formatRupiah(item.sale_price) }}</TableCell>
                    <TableCell>
                      <span :class="{
                        'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-300': item.service_charge_applied,
                        'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-300': !item.service_charge_applied
                      }" class="px-2 py-1 rounded-full text-xs font-medium">
                        {{ item.service_charge_applied ? "Ya" : "Tidak" }}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span :class="{
                        'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-300': item.tax_applied,
                        'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-300': !item.tax_applied
                      }" class="px-2 py-1 rounded-full text-xs font-medium">
                        {{ item.tax_applied ? "Ya" : "Tidak" }}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span :class="{
                        'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-300': item.discount_applied,
                        'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-300': !item.discount_applied
                      }" class="px-2 py-1 rounded-full text-xs font-medium">
                        {{ item.discount_applied ? "Ya" : "Tidak" }}
                      </span>
                    </TableCell>
                    <!-- <TableCell>{{ formatRupiah(item.purchase_price) }}</TableCell> -->
                    <!-- <TableCell>{{ formatRupiah(item.discount_price) }}</TableCell> -->
                    <TableCell>
                      <span :class="{
                        'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-300': item.is_active,
                        'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-300': !item.is_active
                      }" class="px-2 py-1 rounded-full text-xs font-medium">
                        {{ item.is_active ? "Aktif" : "Tidak Aktif" }}
                      </span>
                    </TableCell>
                    <TableCell noTextColor customClass="text-gray-500 dark:text-gray-400 flex">
                      <button :id="'view-data-' + item.id" @click="openStatusModal(item)"
                        class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        Ubah Status
                      </button>
                      <button :id="'view-data-' + item.id" @click="goToStockMovement(item)"
                        class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        Kartu Stok
                      </button>
                      <button :id="'view-data-' + item.id" @click="goToBillOfMaterialDetail(item)"
                        class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        BOM
                      </button>
                      <button :id="'edit-data-' + item.id" @click="editItem(item)"
                        class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        <PencilSquareIcon class="h-4 w-4 group-hover:text-green-700" />
                      </button>
                      <button :id="'delete-data-' + item.id" @click="deleteItem(item)"
                        class="border border-gray-400 hover:border-red-500 hover:bg-red-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        <TrashIcon class="h-4 w-4 group-hover:text-red-700" />
                      </button>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </TableComponent>
              <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from "@/views/IndexView.vue";
import PageTitle from "@/components/PageTitle.vue";
import AddButton from "@/components/buttons/AddButton.vue";
import ModalItem from "@/components/modals/ModalItem.vue";
import ModalConfirmStatus from "@/components/modals/ModalConfirmStatus.vue";
import ViewContainer from "@/components/ViewContainer.vue";
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import { PencilSquareIcon, TrashIcon } from "@heroicons/vue/24/solid";
import { mapGetters, mapActions } from "vuex";
import { formatRupiah } from "@/helpers/formatRupiah";
import defaultBarcode from "@/assets/images/default-image.webp";
import PaginationButtons from "@/components/PaginationButtons.vue";
import { Button, ConfirmDialog, Toast } from "primevue";
import SearchBox from "../new-transaction/SearchBox.vue";
import InputSelect from "@/components/form/InputSelect.vue";

export default {
  name: "ItemView",
  components: {
    IndexView, PageTitle, AddButton, ModalItem, ViewContainer, TableComponent, TableHead, TableRow, TableHeadCell, TableBody, TableCell, PencilSquareIcon, TrashIcon, PaginationButtons, ModalConfirmStatus, ConfirmDialog, Button, Toast, SearchBox, InputSelect
  },
  data() {
    return {
      modalShowItem: false,
      showStatusModal: false,
      selectedItem: null,
      isBlur: false,
      defaultBarcodeImage: defaultBarcode,
      currentPage: 1,
      totalPages: 1,
      searchQuery: "",
      selectedItemCategory: null,
      searchTimeOut: null,
    };
  },
  computed: {
    ...mapGetters("items", ["allItems"]),
    ...mapGetters("item_categories", ["allItemCategories"]),
    categoryOptions() {
      return [
        { name: "Semua Kategori", id: null },
        ...this.allItemCategories.map(item => ({
          name: item.name,
          id: item.id
        }))
      ];
    }
  },
  created() {
    // this.fetchItems();
    this.fetchItems();
    this.$store.dispatch("item_categories/fetchItemCategories", { limit: 1000 });
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(newVal) {
        this.currentPage = newVal;
        this.fetchItems({ page: newVal });
      },
    },
    selectedItemCategory: {
      immediate: true,
      handler() {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = setTimeout(() => {
          this.currentPage = 1;
          this.fetchItems({ page: 1 });
        }, 2000);
      },
    },
    searchQuery: {
      immediate: true,
      handler() {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = setTimeout(() => {
          this.currentPage = 1;
          this.fetchItems({ page: 1 });
        }, 2000);
      },
    },
  },
  methods: {
    ...mapActions("items", ["deleteItemById", "updateItemStatus"]),
    ...mapActions("item_categories", ["fetchItemCategories"]),
    async fetchItems(params = { page: 1, limit: 1000 }) {

      try {
        const response = await this.$store.dispatch("items/fetchItems", {
          limit: 1000
        });

        if (!response) {
          return;
        }
        console.log(this.selectedItemCategory, "selectedItemCategory");

        let data = await this.$store.getters["items/allItems"];
        if (!Array.isArray(data)) {
          return;
        }

        if (data.length === 0) {
          this.$store.commit("items/resetItems");
          this.$store.commit("items/setItems", null);
          this.totalPages = 1;
          this.currentPage = 1;
        }

        if (data && this.searchQuery && this.searchQuery !== "") {
          data = data.filter(item => item.name.toLowerCase().includes(this.searchQuery.toLowerCase()));
        }

        if (data && this.selectedItemCategory) {
          data = data.filter(item => item.item_category_id === this.selectedItemCategory);
        }

        const limits = 10;
        const page = this.currentPage || params.page;
        const startIndex = (page - 1) * limits;
        const endIndex = startIndex + limits;
        const paginatedData = data.slice(startIndex, endIndex);
        this.$store.commit("items/resetItems");
        this.$store.commit("items/setItems", {
          data: paginatedData,
          pagination: {
            total: data.length,
            totalPages: Math.ceil(data.length / limits),
            currentPage: page,
            limit: limits
          }
        });
        this.totalPages = Math.ceil(data.length / limits);
        this.currentPage = page;
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
      } catch (error) {
        console.log(error);
      }
    },
    formatRupiah,
    showModal() {
      this.modalShowItem = true;
      this.isBlur = true;
      this.selectedItem = null;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowItem = false;
        this.isBlur = false;
        this.fetchItems();
      }, 200);
    },
    editItem(item) {
      this.selectedItem = item;
      this.modalShowItem = true;
      this.isBlur = true;
    },
    openStatusModal(item) {
      this.selectedItem = item;
      this.showStatusModal = true;
      this.isBlur = true;
    },
    closeStatusModal() {
      this.showStatusModal = false;
      this.isBlur = false;
      this.selectedItem = null;
    },
    async deleteItem(item) {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menghapus item?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: async () => {
          try {
            await this.deleteItemById(item.id);
            this.fetchItems();
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Berhasil menghapus item', life: 3000 });
          }
          catch (error) {
            console.error('Gagal menghapus item', error);
            this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal menghapus item', life: 3000 });
          }
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Batal menghapus item', life: 3000 });
        }
      });
    },
    getCategoryName(categoryId) {
      const category = this.allItemCategories.find(cat => cat.id === categoryId);
      return category ? category.name : 'Tidak ada kategori';
    },
    goToBillOfMaterialDetail(item) {
      this.$router.push({ name: 'BillOfMaterialSetup', params: { id: item.id } });
    },
    goToStockMovement(item) {
      this.$router.push({ name: 'StockMovement', params: { id: item.id } });
    },
  },
};
</script>